module.exports = __webpack_public_path__ + "static/cinia-64163899f1aa4e32d86d9f209cd59b8d.svg";